"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  fillRule: "evenodd",
  d: "M14.158 5.842H7c-2.21 0-4 1.803-4 4.012v7.58A3.567 3.567 0 0 0 6.567 21h7.59a4 4 0 0 0 4-4V9.854a4.01 4.01 0 0 0-4-4.012M8.08 6.65h5v8.775a.5.5 0 0 1-.812.39l-1.688-1.35-1.688 1.35a.5.5 0 0 1-.812-.39z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17 4.4H9.842a2.6 2.6 0 0 0-2.6 2.6h-1.4a4 4 0 0 1 4-4H17a4 4 0 0 1 4 4v7.158a4 4 0 0 1-4 4v-1.4a2.6 2.6 0 0 0 2.6-2.6V7A2.6 2.6 0 0 0 17 4.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.158 7.242H7a2.61 2.61 0 0 0-2.6 2.612v7.58c0 1.196.97 2.166 2.167 2.166h7.59a2.6 2.6 0 0 0 2.6-2.6V9.854a2.61 2.61 0 0 0-2.6-2.612m0-1.4H7c-2.21 0-4 1.803-4 4.012v7.58A3.567 3.567 0 0 0 6.567 21h7.59a4 4 0 0 0 4-4V9.854a4.01 4.01 0 0 0-4-4.012",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.38 6.65a.7.7 0 0 1 .7-.7h5a.7.7 0 0 1 .7.7v8.775c0 1.006-1.164 1.566-1.95.937l-1.25-1-1.25 1c-.786.629-1.95.07-1.95-.937zm1.4.7v7.659l1.363-1.09a.7.7 0 0 1 .874 0l1.363 1.09v-7.66z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CollectionMultiIcon24.js.map